import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '@cbgms/base/http/use-query'
import { VehicleProvider } from '@cbgms/api'
import { ShopCountry } from '@cbgms/base/shop-id'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { loadModels } from 'app/vehicles/state/actions'
import { useGetModelsCacheKey } from './cacheKeys'

export const useGetModels = (provider: VehicleProvider, country: ShopCountry, brandKey?: string) => {
  const dispatch = useDispatch()
  const { locale } = useContext(LocaleContext)

  return useQuery(
    useGetModelsCacheKey(provider, country, brandKey),
    async () => {
      const { Data } = await dispatch(loadModels(brandKey || '', locale, country, provider))
      return Data
    },
    { enabled: !!brandKey, staleTime: 2 * 60 * 1000 }
  )
}
